import React, { ComponentType, useContext } from 'react';
import { ErrorBoundary } from '@sentry/react';
import styled from 'styled-components';
import TranslationContext from './TranslationContext';
import { ITranslations } from '../../interfaces/ITranslationFields';
import ErrorMessages from '../../views/ErrorMessages';

type WithTranslationsProps = {
  translations?: ITranslations;
};

const ErrorWrapperStyled = styled.p`
  margin: auto;
  padding: 20px;

  p {
    text-align: center;
  }
`;

const withTranslations = <P extends object>(WrappedComponent: ComponentType<P>): ComponentType<P & WithTranslationsProps> => {
  const WithTranslations: React.FunctionComponent<P & WithTranslationsProps> = props => {
    const translations = useContext(TranslationContext) as ITranslations;

    return (
      <ErrorBoundary fallback={<ErrorWrapperStyled><ErrorMessages messages={[translations.contentCannotBeDisplayed]} /></ErrorWrapperStyled>}>
        <WrappedComponent {...props} translations={translations}/>
      </ErrorBoundary>
    );
  };

  return WithTranslations;
};

export default withTranslations;
